import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/defaultContent";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Problem from "@/components/landing/Problem";
import Services from "@/components/landing/Services";
import Why from "@/components/landing/Why";
import Process from "@/components/landing/Process";
import Portfolio from "@/components/landing/Portfolio";
import Pricing from "@/components/landing/Pricing";
import Maintenance from "@/components/landing/Maintenance";
import Booking from "@/components/landing/Booking";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import SeoSchema from "@/components/landing/SeoSchema";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";

export default function Landing() {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const { t } = useLang();
  useSeo({ title: t("seo.title"), description: t("seo.description") });

  useEffect(() => {
    api
      .get("/content")
      .then((res) => {
        if (res.data?.services?.length) setContent(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <main className="bg-ink font-body text-bone">
      <Nav />
      <Hero hero={content.hero} />
      <Marquee />
      <Problem />
      <Services services={content.services} />
      <Why />
      <Process />
      <Portfolio projects={content.projects} />
      <Pricing packages={content.packages} />
      <Maintenance plans={content.maintenance} />
      <Faq faq={content.faq} />
      <Booking packages={content.packages} booking={content.booking} />
      <Footer socials={content.socials} />
      <SeoSchema packages={content.packages} faq={content.faq?.items?.length ? content.faq.items : t("faq.items")} />
    </main>
  );
}
